/**
 * Created by Mikhail Menshenin on 30.07.2025
 */

LoaderScene.startLoading = cleverapps.extendFunc(LoaderScene.startLoading, function (bundleNames, options) {
    if (cleverapps.dataLoader.load("showLoadingOnly")) {
        cleverapps.dataLoader.save("showLoadingOnly", false);
        options.onSuccess = () => { };
    }
    this._super(bundleNames, options);
});

LoaderSceneBackground.prototype.ctor = cleverapps.extendFunc(LoaderSceneBackground.prototype.ctor, function (options) {
    this._super(options);

    if (cleverapps.dataLoader.load("showAgeRestriction")) {
        this.addAgeRestriction();
    }
});

cleverapps.Tool.Debug["show loading scene"] = function () {
    cleverapps.dataLoader.save("showLoadingOnly", true);
    cleverapps.dataLoader.onSaved(() => connector.platform.locationReload());
};

cleverapps.Tool.Debug["show loading age restriction"] = {
    flag: "showAgeRestriction"
};

cleverapps.whenAllInitialized(function () {
    cleverapps.flags.set("showAgeRestriction", cleverapps.dataLoader.load("showAgeRestriction"));
    cleverapps.flags.on("change:showAgeRestriction", () => cleverapps.dataLoader.save("showAgeRestriction", cleverapps.flags.showAgeRestriction));
});